import { api } from ".";

const basePath = "/workPermit";

export const createWorkPermit = async ({
  employeeId,
  start,
  end,
  type,
  note,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      employeeId,
      start,
      end,
      type,
      note,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateSkillById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getWorkPermitsForEmployee = async (params: any = {}) => {
  try {
    const res = await api.get(`${basePath}`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteWorkPermit = async ({
  workPermitId,
  employeeId,
}: {
  workPermitId: string;
  employeeId: string;
}) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: workPermitId, employeeId: employeeId },
    });
    return res;
  } catch (error) {
    return error;
  }
};
